import {gql, useQuery} from '@apollo/client'

const RECENT_RENTALS_FOR_DASHBOARD = gql`
  query recentRentalsForDashboard($filter: RentalsFilterInput, $pagination: Pagination) {
    rental {
      allRentals(filter: $filter, pagination: $pagination) {
        nodes {
          id
          rentStart
          rentEnd
          rentBy {
            id
            __typename
          }
          product {
            id
            name
            imageName
            __typename
          }
          box {
            id
            name
            location {
              id
              name
              __typename
            }
            __typename
          }
          __typename
        }
        totalCount
        __typename
      }
      __typename
    }
  }
`

export const useRecentRentalsForDashboard = (after: string) =>
  useQuery(RECENT_RENTALS_FOR_DASHBOARD, {
    variables: {
      filter: {startDate: {after}},
      pagination: {offset: 0, limit: 5000},
    },
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-and-network',
  })
